import React from 'react'
import screenshotVis from '../../utils/screenshotVis'

import styles from './styles.module.css'

export default function(props) {
  const { view } = props
  // eslint-disable-next-line no-unused-vars
  // function handleClickPNG() {
  //   screenshotVis('png')
  // }
  //
  // // eslint-disable-next-line no-unused-vars
  // function handleClickPDF() {
  //   screenshotVis('pdf')
  // }

  return (
    <div className={styles.footer}>
      <div className={styles.footerText}>
        <p />
        <p>
          Notes: Reflects partial sales data for most recent year. Sale prices in 2020 dollars. Arms length, single family sales only. 2020 sales reflect partial year data. Download CSV file with <a href="/docs/median_sales_price_2020.csv">Median and Mean Single Family Sales Prices, 2000-2020</a> for Florida and all counties.
        </p>
        <p>
          Source: Shimberg Center analysis of{' '}
          <a href="http://floridarevenue.com/property/Pages/DataPortal.aspx">
            Florida Department of Revenue
          </a>{' '}
          Sales Data Files and Name-Address-Legal Files.
        </p>
      </div>
    </div>
  )
}
